import { Component, OnInit  } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { RequestResetPasswordRequest } from '../../models/account/requestResetPasswordRequest';

import { AccountService } from '../../services/account/account.service';
import { HelperService } from '../../services/common/helper.service';
import { TranslationService } from '../../services/common/translation.service';

@Component({
    selector: 'reset-password',
    template: require('./../../templates/account/resetPasswordForm.component.html'),
    providers: [AccountService, HelperService, TranslationService]
})
export class ResetPasswordFormComponent implements OnInit {
    loaded = false;
    isSuccess: boolean;
    errorMessage: string;
    confirmed = false;
    isValid = true;
    isFormValid = true;
    username: string;

    requestResetRequest: RequestResetPasswordRequest = {
        username: '',
        culture: '',
        url: ''
    };

    //Translations
    formUsername: string;
    resetFormPageTitle: string;
    resetFormDescription1: string;
    resetFormDescription2: string;
    formSuccess: string;
    resetFormSuccess: string;
    resetFormResetFail: string;
    resetFormRequestReset: string;
    formBack: string;
    resetFormConfirmReset: string;
    formOops: string;

    constructor(private route: ActivatedRoute, private router: Router, private accountService: AccountService, private helperService: HelperService,
        private translationService: TranslationService) {
    }

    ngOnInit() {
        this.initTranslations();
        this.loaded = true;
    }

    initTranslations(){
        this.translationService.translate('form.username', 'Username', (data) => this.formUsername = data);
        this.translationService.translate('resetForm.pageTitle', 'Reset Password', (data) => this.resetFormPageTitle = data);
        this.translationService.translate('resetForm.description1', 'Reset of password requested for username:', (data) => this.resetFormDescription1 = data);
        this.translationService.translate('resetForm.description2', 'If you did not request this please press "Back" otherwise confirm your request by pressing "Confirm"', (data) => this.resetFormDescription2 = data);
        this.translationService.translate('form.success', 'Success!', (data) => this.formSuccess = data);
        this.translationService.translate('form.back', 'Back', (data) => this.formBack = data);
        this.translationService.translate('resetForm.success', 'Check you email for futher instructions', (data) => this.resetFormSuccess = data);
        this.translationService.translate('resetForm.resetFail', 'Error came up while requesting reset of password, either user does not exist or we had a connection problem. Please try again.', (data) => this.resetFormResetFail = data);
        this.translationService.translate('resetForm.requestReset', 'Reset password', (data) => this.resetFormRequestReset = data);
        this.translationService.translate('form.oops', 'Oops!', (data) => this.formOops = data);
    }

    cancel() {
        this.confirmed = false;
        this.router.navigate(['login'], { queryParams: { redirectUrl: this.route.snapshot.queryParams.redirectUrl } });
    }

    requestResetPassword() {
        this.loaded = false;
        this.errorMessage = '';
        this.isValid = true;

        if (this.validate()) {
            this.requestResetRequest.username = this.username;
            this.requestResetRequest.culture = TranslationService.currentCulture.code;
            this.requestResetRequest.url = encodeURIComponent(this.route.snapshot.queryParams.redirectUrl);

            var result = this.accountService.requestResetPassword(this.requestResetRequest);
            result.subscribe(response => {
                    this.confirmed = true;

                    if (response.success) {
                        this.isSuccess = response.data.result;
                        this.loaded = true;
                        this.isValid = true;
                    } else {
                        this.loaded = true;
                        this.isSuccess = false;
                        if (response.errors != null) {
                            this.isValid = false;
                        }
                    }
                },
                error => {
                    this.confirmed = true;
                    this.loaded = true;
                    this.isSuccess = false;
                    this.isValid = false;
                });
        }
        else {
            this.loaded = true;
            this.isSuccess = false;
            this.isValid = false;
        }
    }

    private addError(code: string, error: string, args: string[]) {
        this.translationService.translate(code, error, (data) => this.errorMessage += '<br /> ' + this.helperService.format(data, args));
    }

    private validate() {
        this.isFormValid = true;

        this.errorMessage = '';
        if (this.helperService.isNullOrEmpty(this.username)) {
            this.addError('loginform.usernameEmpty', 'Username can not be empty', new Array<string>());
            this.isFormValid = false;
        }

        return this.isFormValid;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/components/account/resetPasswordForm.component.ts